export enum EContractType {
  STANDARD = "STANDARD",
  ALPA = "ALPA",
  RMA = "RMA",
}

export enum EContractTypeLabel {
  STANDARD = "Standard Private Sale",
  ALPA = "ALPA Private Sale",
  RMA = "RMA Private Sale",
}

export enum EContractParty {
  BUYER = "buyer",
  VENDOR = "vendor",
}

export const ECONTRACT_TYPES_WITH_SPECIAL_CONDITIONS = [
  EContractType.ALPA,
  EContractType.RMA,
] as const;
